module.exports = __webpack_public_path__ + "static/2nd-tpm-2-311903c05062867984c086a99e8f91c1.jpg";